import { filterClasses } from "@swivl-mono/helpers";
import { useCallback, useEffect, useRef, useState } from "react";
import { IoMdCheckmark } from "react-icons/io";

interface UseSavedIndicatorReturn {
  show: boolean;
  flash: () => void;
}

export function useSavedIndicator(): UseSavedIndicatorReturn {
  const [show, setShow] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const flash = useCallback((): void => {
    setShow(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setShow(false), 2000);
  }, []);

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  return { show, flash };
}

interface SavedIndicatorProps {
  visible: boolean;
}

export function SavedIndicator({ visible }: SavedIndicatorProps): React.ReactNode {
  return (
    <div className={filterClasses("flex items-center gap-0.5 text-teal-600 transition-opacity duration-300", visible ? "opacity-100" : "opacity-0")}>
      <IoMdCheckmark className="size-3" />
      <span className="body-sm">Saved</span>
    </div>
  );
}
